<template>
  <section id="skills" class="py-20">
    <div class="max-w-6xl mx-auto px-6">
      <div class="text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold mb-4" :class="isDark ? 'text-white' : 'text-gray-800'">技能</h2>
        <div class="w-20 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto"></div>
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div 
          v-for="skill in skills" 
          :key="skill.name" 
          class="rounded-xl p-6 transition-all duration-300"
          :class="isDark ? 'bg-gray-700 hover:shadow-xl' : 'bg-white shadow-lg hover:shadow-xl'"
        >
          <div class="flex items-center mb-4">
            <div class="w-12 h-12 rounded-lg flex items-center justify-center" :class="isDark ? skill.darkBgColor : skill.bgColor">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" :class="isDark ? skill.darkIconColor : skill.iconColor" fill="currentColor" viewBox="0 0 20 20">
                <path :d="skill.icon" />
              </svg>
            </div>
            <h3 class="ml-4 text-xl font-semibold" :class="isDark ? 'text-white' : 'text-gray-800'">{{ skill.name }}</h3>
          </div>
          <div class="space-y-3">
            <div v-for="item in skill.items" :key="item.name">
              <div class="flex justify-between text-sm mb-1">
                <span :class="isDark ? 'text-gray-300' : 'text-gray-600'">{{ item.name }}</span>
                <span :class="isDark ? 'text-gray-400' : 'text-gray-500'">{{ item.level }}</span>
              </div>
              <div class="w-full rounded-full h-2" :class="isDark ? 'bg-gray-600' : 'bg-gray-200'">
                <div class="h-2 rounded-full transition-all duration-500" :class="skill.barColor" :style="{ width: item.percentage + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useTheme } from '../composables/useTheme'

export default {
  name: 'Skills',
  setup() {
    const { isDark } = useTheme()
    return { isDark }
  },
  data() {
    return {
      skills: [
        {
          name: '前端开发',
          icon: 'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z',
          bgColor: 'bg-blue-100',
          iconColor: 'text-blue-600',
          darkBgColor: 'bg-blue-500/20',
          darkIconColor: 'text-blue-400',
          barColor: 'bg-blue-500',
          items: [
            { name: 'Vue.js', level: '精通', percentage: 95 },
            { name: 'React', level: '熟练', percentage: 85 },
            { name: 'TypeScript', level: '熟练', percentage: 88 },
            { name: 'CSS/Sass', level: '精通', percentage: 92 }
          ]
        },
        {
          name: '后端开发',
          icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
          bgColor: 'bg-green-100',
          iconColor: 'text-green-600',
          darkBgColor: 'bg-green-500/20',
          darkIconColor: 'text-green-400',
          barColor: 'bg-green-500',
          items: [
            { name: 'Node.js', level: '精通', percentage: 90 },
            { name: 'Python', level: '熟练', percentage: 82 },
            { name: 'MongoDB', level: '熟练', percentage: 85 },
            { name: 'MySQL', level: '熟练', percentage: 80 }
          ]
        },
        {
          name: '工具与部署',
          icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z',
          bgColor: 'bg-purple-100',
          iconColor: 'text-purple-600',
          darkBgColor: 'bg-purple-500/20',
          darkIconColor: 'text-purple-400',
          barColor: 'bg-purple-500',
          items: [
            { name: 'Git', level: '精通', percentage: 95 },
            { name: 'Docker', level: '熟练', percentage: 78 },
            { name: 'AWS', level: '熟悉', percentage: 70 },
            { name: 'CI/CD', level: '熟练', percentage: 82 }
          ]
        }
      ]
    }
  }
}
</script>
